<template>
  <span :class="style.heading">MAX</span>
  <div :class="style.inputs">
    <InputStyle
      size="M"
      placeholder="Введите название"
      description="Название интеграции"
      v-model="localIntegration.name"
    />
    <InputStyle
      v-if="edit"
      size="M"
      placeholder="Имя заявки"
      description="Введите имя заявки"
      v-model="localIntegration.nameApplication"
    />
    <InputStyle
      size="M"
      placeholder="-1002128412195 или 12674359"
      description="ID группы или user_id получателя"
      v-model="localIntegration.id"
    />
  </div>
  <div :class="style.buttons">
    <PrimaryButton
      :text="edit ? 'Сохранить' : 'Добавить интеграцию'"
      @click="saveIntegration"
    />
    <SecondaryButton
      v-if="edit"
      text="Удалить"
      :icon="trashIcon"
      @click="$emit('delete')"
    />
  </div>
</template>

<script lang="ts">
import {defineComponent, PropType} from "vue";
import style from "./settingIntegrations.module.scss";
import PrimaryButton from "@/elements/UI/button/ButtonStyle/Default/primary/PrimaryButton.vue";
import SecondaryButton from "@/elements/UI/button/ButtonStyle/Default/secondary/SecondaryButton.vue";
import InputStyle from "@/elements/UI/input/Style/InputStyle.vue";
import trashIcon from "$images/icons/button/Name=Trash, Size=16, Tone=Default.svg";
import {maxIntegration} from "@/page/setting/integration/IntegrationTypes";

export default defineComponent({
  name: "SettingIntegrationMax",
  components: {InputStyle, SecondaryButton, PrimaryButton},
  emits: ["delete", "closeModal"],
  props: {
    edit: {type: Boolean, default: false},
    integration: {
      type: Object as PropType<maxIntegration>,
      default: () => ({})
    },
    integrationIndex: {type: Number, default: 0}
  },
  data() {
    return {
      style,
      trashIcon,
      localIntegration: {
        name: this.integration?.name || "",
        id: String(this.integration?.id ?? ""),
        nameApplication: this.integration?.nameApplication || ""
      }
    };
  },
  methods: {
    saveIntegration() {
      const integration = this.getIntegration.max;
      if (!integration) return;

      if (
        this.edit &&
        this.integrationIndex >= 0 &&
        this.integrationIndex < integration.integration.length
      ) {
        integration.integration[this.integrationIndex] = {
          ...this.localIntegration
        };
      } else {
        integration.integration.push({...this.localIntegration});
      }

      this.$emit("closeModal");
    }
  },
  computed: {
    getIntegration() {
      return this.$integrationStore.getIntegration;
    }
  },
  watch: {
    integration: {
      immediate: true,
      deep: true,
      handler(newVal) {
        if (!newVal) return;
        this.localIntegration = {
          name: newVal.name || "",
          id: String(newVal.id ?? ""),
          nameApplication: newVal.nameApplication || ""
        };
      }
    }
  }
});
</script>
